import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface CarveInNameCellRendererComponentParams {
  cellField: string;
  isCarveIn: boolean;
  productCount?: number;
}

@Component({
    template: ` @if (!isCarveIn) {
    {{ cellField }}
    } @else {
    <div
      [attr.data-test-selector]="cellField + '-carve-in'"
      class="font-italic text-truncate"
    >
      {{ cellField }}
      <span class="badge bg-secondary">{{ productCount }} Products</span>
    </div>
    }`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarveInNameCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  cellField!: string;
  isCarveIn!: boolean;
  productCount?: number;

  agInit({ cellField, isCarveIn, productCount }: CustomParams): void {
    this.cellField = cellField;
    this.isCarveIn = isCarveIn;
    this.productCount = productCount;
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}

interface CustomParams
  extends ICellRendererParams<unknown, unknown>,
    CarveInNameCellRendererComponentParams {}
